// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as TbAtoms from "./TbAtoms.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as TbUnitSource from "./TbUnitSource.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";

function TbTraitUnitsGrid(Props) {
  var unitSearchMatches = Props.unitSearchMatches;
  var addUnit = Props.addUnit;
  var allTraits = Props.allTraits;
  var exaltedUnits = Props.exaltedUnits;
  var set = TftSet.use(undefined);
  var match = Jotai.useAtom(TbAtoms.disableTooltips);
  var disableTooltips = match[0];
  return React.createElement("div", {
              className: "flex flex-wrap justify-between bg-bg sm:max-w-[486px] lg:max-w-[545px] xl:max-w-[781px]"
            }, Belt_Array.map(allTraits, (function (traitId) {
                    var units = traitId === "TFT11_Exalted" ? Belt_Option.getWithDefault(exaltedUnits, []) : Sd.getTraitUnits(traitId, set);
                    return React.createElement("div", {
                                key: traitId,
                                className: "flex w-full xl:w-6/12 pt-3"
                              }, React.createElement("div", {
                                    className: "w-[46px] h-[46px] ml-2 flex items-center justify-center"
                                  }, React.createElement(TraitTooltip.make, {
                                        disabled: disableTooltips,
                                        trait: traitId,
                                        children: React.createElement(TraitImage.PlainIcon.make, {
                                              traitId: traitId,
                                              size: 34
                                            })
                                      })), React.createElement("div", {
                                    className: "grid gap-[6px] sm:gap-[9px] px-[10px] pl-[8px] pb-[8px] grid-cols-[repeat(6,44px)] sm:grid-cols-[repeat(10,47px)] md:grid-cols-[repeat(10,46px)] lg:grid-cols-[repeat(7,46px)] xl:grid-cols-[repeat(6,46px)]"
                                  }, Belt_Array.map(Belt_SortArray.stableSortBy(units, (function (u1, u2) {
                                              return Caml.caml_int_compare(Sd.unitTier(u1), Sd.unitTier(u2));
                                            })), (function (unit) {
                                          return React.createElement(TbUnitSource.make, {
                                                      searchMatch: unitSearchMatches !== undefined ? unitSearchMatches.includes(unit) : true,
                                                      highlight: true,
                                                      unit: unit,
                                                      size: 44,
                                                      sizeSm: 47,
                                                      sizeMd: 46,
                                                      onClick: addUnit,
                                                      key: unit
                                                    });
                                        }))));
                  })));
}

var make = TbTraitUnitsGrid;

export {
  make ,
  
}
/* Sd Not a pure module */
